class KiziLogEvent {
  applicationName: string;
  clientId: string;
  sequenceId = '';
  logs: KiziLog[] = [];
  constructor(
    applicationName: string,
    clientId: string,
    sequenceId: string,
    logs: KiziLog[]
  ) {
    this.applicationName = applicationName;
    this.clientId = clientId;
    this.sequenceId = sequenceId;
    this.logs = logs;
  }
}

export interface IKiziLog {
  eventId: number;
  eventName: string;
  message: string;
  member: string;
  data: any;
}

export class KiziLog {
  eventId!: number;
  eventName!: string;
  eventDateTime!: string;
  member!: string;
  message!: string;
  duration!: number;
  data!: any;

  /*
  The KiziLogger.logError parameters
  Provide an unique log number per log location in code to easily search for the specific use.
  Give the log an event name.
  Provide some member info. e.g. the file and method name
  The error message
  Some object with data, keep it small
  */
  constructor(
    eventId: number,
    eventName: string,
    member: string,
    message: string,
    data: any = {}
  ) {
    this.eventId = eventId;
    this.eventName = eventName;
    this.member = member;
    this.message = message;
    this.data = data;
  }

  setDateStamp() {
    this.eventDateTime = this.getDateWithFormat();
  }

  private getDateWithFormat(): string {
    let date = new Date();
    return (
      date.getFullYear() +
      '-' +
      this.leftpad(date.getMonth() + 1, 2) +
      '-' +
      this.leftpad(date.getDate(), 2) +
      'T' +
      this.leftpad(date.getHours(), 2) +
      ':' +
      this.leftpad(date.getMinutes(), 2) +
      ':' +
      this.leftpad(date.getSeconds(), 2)
    );
  }

  private leftpad(val: number, resultLength = 2, leftpadChar = '0'): string {
    return (String(leftpadChar).repeat(resultLength) + String(val)).slice(
      String(val).length
    );
  }
}

export class KiziLogger {
  private static delay = 5000;
  private static timer: any;
  private static sequenceId = '';
  private static logs: KiziLog[] = [];
  private static failed = 0;
  static applicationName: string;
  static logApiUrl: string;
  static clientId: string;
  static jwt: string | null;

  static initialize(logApiUrl: string, applicationName: string): void {
    KiziLogger.logApiUrl = logApiUrl;
    KiziLogger.applicationName = applicationName;
    if (!KiziLogger.timer)
      KiziLogger.timer = setInterval(() => {
        this.sendBatch();
      }, KiziLogger.delay);
  }

  static setJwt(jwt: string): void {
    this.jwt = jwt;
  }

  static setClientId(clientId: string): void {
    this.clientId = clientId;
  }

  static logError(logData: IKiziLog): void {
    // console.log('Logger data');
    // console.log(logData);
    const { eventId, eventName, member, message, data } = logData;
    const log = new KiziLog(eventId, eventName, member, message, data);
    log.setDateStamp();
    KiziLogger.logs.push(log);
    (window as any)?.dataLayer?.push({
      event: 'error_messages',
      component: member,
      error_message: message,
    });
  }

  private static sendBatch() {
    try {
      if (
        KiziLogger.logs.length === 0 ||
        !KiziLogger.jwt ||
        !KiziLogger.applicationName ||
        !KiziLogger.logApiUrl
      )
        return;

      let logCopy: KiziLog[] = [];
      for (let i = KiziLogger.logs.length - 1; i >= 0; i--) {
        logCopy.push(KiziLogger.logs[i]);
        KiziLogger.logs.splice(i, 1);
        if (logCopy.length > 20) break;
      }

      logCopy.sort((a, b) => (a.eventDateTime > b.eventDateTime ? 1 : -1));
      let batch: KiziLogEvent = new KiziLogEvent(
        KiziLogger.applicationName,
        KiziLogger.clientId,
        KiziLogger.sequenceId,
        logCopy
      );
      this.post(
        KiziLogger.logApiUrl,
        batch,
        (result) => {
          KiziLogger.sequenceId = result.sequenceId;
          KiziLogger.failed = 0;
          KiziLogger.delay = 5000;
        },
        (oldLogs: KiziLog[]) => {
          if (KiziLogger.failed < 4) KiziLogger.failed++;
          KiziLogger.delay = 10000 * KiziLogger.failed;
          for (let log of oldLogs) {
            KiziLogger.logs.push(log);
          }
        }
      );
    } catch (ex) {
      console.log(ex);
    }
  }

  private static post(
    url: string,
    data: KiziLogEvent,
    callback: (result: { message: string; sequenceId: string }) => void,
    errorCallback: (logs: KiziLog[]) => void
  ) {
    let xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.onload = function () {
      callback(JSON.parse(this['responseText']));
    };
    xhr.onerror = function () {
      errorCallback(data.logs);
    };
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 401) {
        //Token not valid
        KiziLogger.jwt = null;
      }
    };
    xhr.setRequestHeader('Content-Type', 'application/json');
    if (typeof KiziLogger.jwt === 'string') {
      xhr.setRequestHeader('Authorization', KiziLogger.jwt);
    }
    if (data != null) {
      xhr.send(JSON.stringify(data));
    }
  }
}
